var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSinkBadge = function SvgSinkBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDAC8",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 15.126C7.625 16.16 8.465 17 9.5 17h5c1.035 0 1.875-.84 1.875-1.875V14.5h-8.75v.625zm9.062-2.5h-1.875V12h1.25c.173 0 .313-.14.313-.313v-.312a.313.313 0 00-.313-.313H14.5a.625.625 0 00-.625.625v.938h-1.25v-3.75a.625.625 0 011.25 0v.312c0 .173.14.313.312.313h.625c.173 0 .313-.14.313-.313v-.312a1.879 1.879 0 00-2.249-1.84c-.89.174-1.501 1.007-1.501 1.914v3.676h-1.25v-.938a.625.625 0 00-.625-.625H7.937a.313.313 0 00-.312.313v.312c0 .173.14.313.312.313h1.25v.625H7.312a.313.313 0 00-.312.312v.625c0 .172.14.313.312.313h9.375c.173 0 .313-.14.313-.313v-.625a.313.313 0 00-.313-.312z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgSinkBadge;